export const sampleProducts = [
    {
        "amountDue": 0,
"billTo": "102186",
"checkNumber": 0,
"invoiceDate": "120044",
"invoiceNumber": 1191681,
"invoiceStatus": null,
"jobName": "407 Lenox",
"marketSegment": null,
"originalAmount": 0,
"poNumber": "3862711",
"type": "RI"
    }
];